import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Notification() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center xl:p-5 sm:p-0 justify-center">
      <div className="w-full border rounded-3xl shadow-sm bg-[#F9FAFB]">
        {/* Tabs header */}
        <div className="px-6 pt-6 pb-2 bg-gradient-to-r from-[#F8FFFE] to-[#F5FAFF] rounded-t-3xl">
          <h1 className="text-2xl font-bold text-gray-800">{t("adminDash.notifications")}</h1>
          <p className="text-xs text-gray-500 mt-1">{t("adminDash.notification.adminFeed")}</p>
          <div className="mt-5 flex flex-wrap items-center gap-2">
            <NavLink to=".././all-notification" className={({ isActive }) =>
              `inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                isActive ? "bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white" : "bg-white text-gray-700 border border-gray-200 hover:bg-[#E6FFFB] hover:text-[#169d8f]"
              }`
            }>
              {t("adminDash.studentNoti.all")}
            </NavLink>
            <NavLink to=".././new-notification" className={({ isActive }) =>
              `inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                isActive ? "bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white" : "bg-white text-gray-700 border border-gray-200 hover:bg-[#E6FFFB] hover:text-[#169d8f]"
              }`
            }>
              {t("adminDash.studentNoti.new")}
            </NavLink>
            <NavLink to=".././unread-notification" className={({ isActive }) =>
              `inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium transition-colors ${
                isActive ? "bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white" : "bg-white text-gray-700 border border-gray-200 hover:bg-[#E6FFFB] hover:text-[#169d8f]"
              }`
            }>
              {t("adminDash.studentNoti.unread")}
            </NavLink>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 py-10">
          <div className="rounded-2xl border bg-white p-6 text-center">
            <h2 className="text-lg font-semibold text-gray-800">{t("adminDash.notification.pickATab")}</h2>
            <p className="mt-1 text-sm text-gray-500">
              {t("adminDash.notification.pickATabDescription")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
